import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DiagnosisService } from 'src/app/diagnosis.service';
import { GastroFormsService } from 'src/app/gastro-forms.service';
import { PathologyService } from 'src/app/pathology.service';
import { PrintService } from 'src/app/print.service';

@Component({
    selector: 'app-gsprint-form',
    templateUrl: './gsprint-form.component.html',
    styleUrls: ['./gsprint-form.component.scss'],
    standalone: false
})
export class GsprintFormComponent implements OnInit {
  FormID:number;
  PID:number;
  now:Date;
  
  Direction='ltr';
  
  showCharts = false;
  loaded=false;
  hasImages = false;
  imPerPage = 2;
  mct = 0;
  altHeader:SafeHtml;
  showHeader = true;
  showHistory = true;
  groups = ['Mitral','Tricuspid','Aortic','Pulmonic','LVOT']

  constructor(public gfs:GastroFormsService,public pathologyS:PathologyService,private ds: DiagnosisService,private route: ActivatedRoute, public print:PrintService, public translate: TranslateService, private sanitizer: DomSanitizer) {
    this.now=new Date();
   }

  ngOnInit() {
    this.translate.use(this.route.snapshot.params.LANG);
    if(this.route.snapshot.params.LANG == 'he-IL' || this.route.snapshot.params.LANG == 'ar-JO')
      this.Direction='rtl';
    
      this.loaded=true;
    let code = this.route.snapshot.params['code'];
    this.FormID = this.route.snapshot.params.examid;
    this.PID= this.route.snapshot.params.PID;
    if(this.route.snapshot.params["images"] == "y"){
      this.hasImages = true;
      this.imPerPage = this.route.snapshot.params["perpage"];
    }
    if(this.route.snapshot.params["perpage"] == "All"){
      this.hasImages = true;
      this.imPerPage = 2;
      this.print.allImages = true;
    }
    else
      this.print.allImages = false;
    if(this.route.snapshot.params.hasOwnProperty('showheader'))
      this.showHeader = this.route.snapshot.params['showheader'] == 'y';
    this.gfs.loadExam(this.FormID,this.PID, this.hasImages,code);
    this.print.loadMsg.subscribe(()=> {
      if(this.route.snapshot.params.charts == 'y')
        this.showCharts=true;
      // if(this.print.env['htmlheader']){
      //   this.altHeader=this.sanitizer.bypassSecurityTrustHtml(this.print.env['htmlheader']);
      // }
    });
    this.gfs.htmlHeaderLoad$.subscribe((data:any)=>{
      this.altHeader=this.sanitizer.bypassSecurityTrustHtml(data)
    })
  }
  translatePainLevel(value: string): string {
    let painLevel: string = "";

    if (value === "painless") {
      painLevel = "אין כאב בכלל";
    }

    if (value === "lowPain") {
      painLevel = "כאב מועט";
    }

    if (value === "mediumPain") {
      painLevel = "כאב בינוני";
    }

    if (value === "strongPain") {
      painLevel = "כאב חזק";
    }

    if (value === "fullPain") {
      painLevel = "כאב בלתי נסבל";
    }
    return painLevel;
  }

  
getExamPerformedString() {
  const examsPerformed = [];
  
  if (this.gfs.form.Gastroscopy === true || this.gfs.form.Gastroscopy == 1) {
    examsPerformed.push("גסטרוסקופיה");
  }

  if (this.gfs.form.Colonoscopy === true || this.gfs.form.Colonoscopy == 1) {
    examsPerformed.push("קולונוסקפיה");
  }

  if (this.gfs.form.Sigmoidoscopy === true || this.gfs.form.Sigmoidoscopy == 1) {
    examsPerformed.push("סיגמאידוסקופיה");
  }

  return examsPerformed.join(', ');
}


ngOnDestroy(): void {
  this.gfs.htmlHeaderLoad$.unsubscribe();
}
}

